import React, { Component } from 'react'
import { Card, Button, Form, Message } from 'semantic-ui-react'
import { connect } from 'react-redux'

import actions from '../redux/actions'

import './LoginPage.css'

class LoginPage extends Component {
  constructor (props) {
    super(props)

    this.state = {
      email: '',
      password: ''
    }
  }

  componentDidMount () {
    this.maybeRedirectToApp()
  }

  componentDidUpdate () {
    this.maybeRedirectToApp()
  }

  maybeRedirectToApp () {
    if (this.props.isAuthenticated) {
      this.props.history.replace('/app')
    }
  }

  render () {
    const { isAuthenticating, error } = this.props

    return (
      <div className='LoginPage'>
        <Card fluid className='LoginPage-card' centered>
          <Card.Content>
            <Card.Header textAlign='center' style={{ marginTop: '0.5rem' }}>
              Login to your account
            </Card.Header>
            <Card.Content style={{ marginTop: '1.5rem' }}>
              {error && this.renderError()}
              <Form size='large' onSubmit={this.handleSubmit}>
                <Form.Input
                  id='email'
                  value={this.state.email}
                  onChange={this.handleChange}
                  fluid
                  type='email'
                  icon='user'
                  iconPosition='left'
                  placeholder='Email address'
                  disabled={isAuthenticating}
                />

                <Form.Input
                  id='password'
                  value={this.state.password}
                  onChange={this.handleChange}
                  fluid
                  icon='lock'
                  type='password'
                  iconPosition='left'
                  placeholder='Password'
                  disabled={isAuthenticating}
                />

                <Button
                  type='submit'
                  disabled={!this.validateForm()}
                  primary
                  fluid
                  loading={isAuthenticating}
                >
                  Login
                </Button>
              </Form>

            </Card.Content>
          </Card.Content>
        </Card>
      </div>
    )
  }

  renderError = () => {
    const { error } = this.props
    return (
      <Message negative>
        <Message.Header>
          Login failed
        </Message.Header>
        <p>{error}</p>
      </Message>
    )
  }

  validateForm () {
    return (
      this.state.email.length > 0 &&
      this.state.password.length > 0 &&
      !this.props.isAuthenticating
    )
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    })
  }

  handleSubmit = async event => {
    event.preventDefault()
    const { email, password } = this.state
    this.props.login({ email, password })
  }
}

const mapStateToProps = state => ({
  isAuthenticating: state.user.isAuthenticating,
  isAuthenticated: state.user.isAuthenticated,
  error: state.user.error
})

const mapDispatchToProps = dispatch => ({
  login: ({ email, password }) =>
    dispatch(actions.user.login({ email, password }))
})

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage)



// WEBPACK FOOTER //
// ./src/containers/LoginPage.js